var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.0001,
    r: 25,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3360_4936",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.0001,
    r: 25,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3360_4936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0823 42.9611L9.09448 47.379C8.62573 47.6382 8.20447 47.9568 7.8125 48.304C12.4696 52.2856 18.4815 54.6876 25.05 54.6876C31.57 54.6876 37.5435 52.3214 42.1875 48.3941C41.7592 48.0274 41.2945 47.6976 40.7792 47.4374L32.2257 43.1014C31.1205 42.5411 30.4224 41.3959 30.4224 40.1432V36.7404C30.6628 36.4628 30.9376 36.1063 31.2316 35.6853C32.3974 34.0157 33.2793 32.179 33.8905 30.2523C34.9876 29.9091 35.7958 28.8817 35.7958 27.6607V24.0285C35.7958 23.2295 35.4452 22.5155 34.9007 22.0156V16.7649C34.9007 16.7649 35.9645 8.59387 25.051 8.59387C14.1375 8.59387 15.2013 16.7649 15.2013 16.7649V22.0156C14.6558 22.5155 14.3062 23.2295 14.3062 24.0285V27.6607C14.3062 28.6174 14.8023 29.4594 15.5448 29.946C16.4398 33.8968 18.7836 36.7404 18.7836 36.7404V40.0592C18.7826 41.2679 18.13 42.3813 17.0823 42.9611Z",
    fill: "#DDEAFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.e19824cc3baf01c76a87b9b50bfd5ee6.svg";
export { ForwardRef as ReactComponent };